import React from 'react';
import { t } from '../../services/i18nService';
import viewReadyTracker from '../../services/ViewReadyTracker';
import styles from './generalErrorPage.scss';
import AdditionalResourcesBar from '../additionalResourcesBar/AdditionalResourcesBar';

class EmptyQuestionSetPage extends React.PureComponent {
    componentDidMount() {
        viewReadyTracker.getReporter()(true);
    }

    onCloseClick() {
        if (window.bridgeCallbacks) {
            window.bridgeCallbacks.closeWindow();
        } else {
            window.close();
        }
    }

    render() {
        return (
            <React.Fragment>
                <div className={styles.errorPage} role="main">
                    <i className="fa fa-th fa-2x" />
                    <p className="title">{t('EmptyQuestionSet.title')}</p>
                    <p className="message">{t('EmptyQuestionSet.message')}</p>
                    <button className={styles.closeButton} onClick={this.onCloseClick}>
                        {t('general.close')}
                    </button>
                </div>
                <div className={styles.additionalResourcesWrapper}>
                    <AdditionalResourcesBar />
                </div>
            </React.Fragment>
        );
    }
}

export default EmptyQuestionSetPage;
